/**
 * Validates a form field value against validation rules
 * @param value Value to validate
 * @param rules Object containing validation rules
 * @returns True if validation passes, false otherwise
 */
export const validateFields = (value: string | undefined, rules: Record<string, (val: string) => boolean | string>) => {
    return Object.values(rules).every(rule => rule(value || '') === true);
};
